import Meta from 'src/components/meta/Meta';

const TermsMeta = () => <Meta
  title="Terms and Conditions | BrickX"
  description="The BrickX Terms and Conditions outline everything you need to know regarding the rules and regulations of the BrickX Platform."
/>;

export default TermsMeta;
